export const SERVICE = {
  PROMO_V2: import.meta.env.VITE_APP_SERVICE_PROMO_V2 || "",
  AUTH: import.meta.env.VITE_APP_SERVICE_AUTH || "",
  FLAGGING: import.meta.env.VITE_APP_SERVICE_FLAGGING || "",
  RECOMMENDATION: import.meta.env.VITE_APP_SERVICE_RECOMMENDATION || "",
};
